import { createSlice } from '@reduxjs/toolkit'
import { fetchBSReport } from './thunks/balanceSheet';

const initialState = {
    data: "",
    isLoading: false,
    error: null,
    isNoteActive: false
}

const balanceSheet = createSlice({
    name: 'BALANCESHEETSLICE',
    initialState,
    reducers: {
        addSymbols(state, action){
            state.availableSymbols = action.payload
        },
        setBsNoteActiveState(state, action){
          state.isNoteActive = !state.isNoteActive
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchBSReport.pending, (state) => {
          state.isLoading = true
        })
        builder.addCase(fetchBSReport.fulfilled, (state, action) => {
          state.isLoading = false
          state.data = action.payload
        })
        builder.addCase(fetchBSReport.rejected, (state, action) => {
          state.isLoading = false
          state.error = action.error.message
          state.data = null
        })
    }
});

export const { addSymbols, data, setBsNoteActiveState } = balanceSheet.actions

export default balanceSheet;